exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.delete-user-message[data-v-4078565e] {\n  padding: 20px;\n  text-align: center;\n  color: #f44336;\n  font-size: 16px;\n  font-weight: 500;\n}\n.delete-user-container[data-v-4078565e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: #1482c4;\n  width: 100%;\n  height: 100vh;\n}\n#deleteUserButton[data-v-4078565e] {\n  background-color: #f44336;\n  color: white;\n  margin: 10px 0;\n}\n", ""]);

// exports
